import { useEffect, useState } from "react";
import { Card, FloatingLabel, Form } from "react-bootstrap";
import LoadingComponent from "../widgets/LoadingComponent";
import { useNavigate, useParams } from "react-router-dom";
import { useInfoUser } from "../helper/authHelper";
import { postData, urlApiProduccion } from "../api/ApiRest";

function GestionarClave() {
    const navigate = useNavigate();
    const { User, Company } = useInfoUser();

    const [nitCompany, setNitCompany] = useState('');
    const [userName, setUserName] = useState('');
    const [codeGenerated, setCodeGenerated] = useState('');
    const [loading, setLoading] = useState(false);

    const [activateCode, setActivateCode] = useState(false);
    const [usuarioModificado, setUsuarioModificado] = useState(null);
    const [password, setpassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const identificador = useParams().id;

    useEffect(() => {
        if (identificador === 'yy')
            setUserName(User);
        else
            setUserName('');

        setNitCompany('');
        setCodeGenerated('');

        setUsuarioModificado(null);
        setpassword('');
        setConfirmPassword('');
    }, [identificador])

    ///Función que me permite capturar el enter en cada input cuando estoy realizando el proceso de cambio de clave
    const handleKeyDown = (e, tipo) => {
        if (e.key === "Enter") {
            e.preventDefault();

            if (tipo === '1') ///Primero valida el usuario
                validarInfo();
            else if (tipo === '2')///Valida el codigo digitado
                verificarCodigo();
            else if (tipo === '3') ///Procede a cambiar la clave de acuerdo a la confirmación
                cambiarClave();
        }
    };

    ///Función para validar que el usuario con el nit ingresado corresponda a uno previamente registrado
    const validarInfo = () => {
        setLoading(true);

        ///Validamos como se procede a ejecutar la función, todo depende de si es desde el login o si es desde el menú
        if (identificador === 'yy') {
            postData('api/Configuracion/AdminEnvio/validarInfoUsuario', {}, {
                nit: nitCompany,
                usuario: userName,
                tipo: identificador
            }).then(response => {
                if (response.status) {
                    alert(response.msj);
                    setActivateCode(true);
                } else
                    alert(response.msj);

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
            })
        } else {
            fetch(urlApiProduccion + 'api/Configuracion/AdminEnvio/validarInfoUsuario', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    nit: nitCompany,
                    usuario: userName,
                    tipo: identificador
                })
            }).then(response => response.json())
                .then(response => {
                    if (response.status) {
                        alert(response.msj);
                        setActivateCode(true);
                    } else
                        alert(response.msj);

                    setLoading(false);

                }, error => {
                    console.log(error, 'error');
                    setLoading(false);
                })
        }
    }

    ///De acuerdo al nit, usuario y codigo registrado se valida si el usuario puede o no cambiar la contraseña
    const verificarCodigo = () => {
        setLoading(true);

        ///Validamos como se procede a ejecutar la función, todo depende de si es desde el login o si es desde el menú
        if (identificador == 'yy') {
            postData('api/Configuracion/AdminEnvio/validateUsuarioCode', {}, {
                nit: nitCompany,
                usuario: userName,
                code: codeGenerated,
                tipo: identificador
            }).then(response => {
                if (response.status) {
                    alert(response.msj);
                    setUsuarioModificado(response.usuarioid);
                } else {
                    alert(response.msj);
                }

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
            })
        } else {
            fetch(urlApiProduccion + 'api/Configuracion/AdminEnvio/validateUsuarioCode', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    nit: nitCompany,
                    usuario: userName,
                    code: codeGenerated,
                    tipo: identificador
                })
            }).then(response => response.json())
                .then(response => {
                    if (response.status) {
                        alert(response.msj);
                        setUsuarioModificado(response.usuarioid);
                    } else {
                        alert(response.msj);
                    }

                    setLoading(false);

                }, error => {
                    console.log(error, 'error');
                    setLoading(false);
                })
        }
    }

    ///Función que permite cambiar la clave después de pasar todas las validaciones previas
    const cambiarClave = () => {
        setLoading(true);

        ///Validamos como se procede a ejecutar la función, todo depende de si es desde el login o si es desde el menú
        if (identificador === 'yy') {
            postData('api/Configuracion/AdminEnvio/cambiarClaveUsuario', {}, {
                usuarioid: usuarioModificado,
                clave1: password,
                clave2: confirmPassword
            }).then(response => {
                if (response.status) {
                    alert(response.msj);
                    navigate('/');
                    window.location.reload();
                } else {
                    alert(response.msj);
                }

                setLoading(false);
            }, error => {
                console.log(error);
                setLoading(false);
            })
        } else {
            fetch(urlApiProduccion + 'api/Configuracion/AdminEnvio/cambiarClaveUsuario', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    usuarioid: usuarioModificado,
                    clave1: password,
                    clave2: confirmPassword
                })
            }).then(response => response.json())
                .then(response => {
                    if (response.status) {
                        alert(response.msj);

                        ///Si es cambio de contraseña normal regresa a home, si es olvido su contraseña lo envía hacía el login
                        if (identificador === 'yy') {
                            navigate('/home');
                        } else {
                            navigate('/');
                        }

                        window.location.reload();
                    } else {
                        alert(response.msj);
                    }

                    setLoading(false);

                }, error => {
                    console.log(error, 'error');
                    setLoading(false);
                })
        }
    }

    return (
        <>
            {<LoadingComponent Loading={loading} />}
            <div className="row mt-4">
                <div className='col-md-4'></div>
                <div className='col-md-4'>
                    <Card>
                        <Card.Header className='fw-bold text-center'
                            style={{ fontSize: 20 }}>
                            GESTIÓN CLAVE TAE-COL
                        </Card.Header>
                        <Card.Body>
                            <div className='text-center'>
                                <img
                                    alt=""
                                    src="/TaePreguntando.gif"
                                    style={{ width: '150px' }}
                                    className="text-center"
                                />
                            </div>
                            <div>
                                {!usuarioModificado ?
                                    <>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Nit Empresa"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="text"
                                                placeholder="Nit Empresa"
                                                size='sm'
                                                required={identificador === 'yy' ? false : true}
                                                disabled={identificador === 'yy' ? true : false}
                                                value={nitCompany}
                                                autoComplete='off'
                                                onChange={text => {
                                                    setNitCompany(text.target.value)
                                                }}
                                            />
                                        </FloatingLabel>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Usuario"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="email"
                                                placeholder="Email"
                                                size='sm'
                                                required={true}
                                                value={userName}
                                                autoComplete='off'
                                                onChange={text => {
                                                    setUserName(text.target.value)
                                                }}
                                                onKeyDown={(event) => handleKeyDown(event, '1')}
                                            />
                                        </FloatingLabel>
                                        {!activateCode ?
                                            <div className="d-grid gap-2">

                                                <button type='submit'
                                                    style={{ background: '#327189' }}
                                                    className='btn btn-sm' onClick={validarInfo}>
                                                    <div className='text-center text-white fw-bold m-2'>GENERAR CODIGO</div>
                                                </button>
                                            </div>
                                            :
                                            <>
                                                <FloatingLabel
                                                    controlId="floatingInput"
                                                    label="Código"
                                                    className="mb-3"
                                                >
                                                    <Form.Control
                                                        type="number"
                                                        placeholder="Código"
                                                        size='sm'
                                                        required={true}
                                                        value={codeGenerated}
                                                        autoComplete='off'
                                                        onChange={text => {
                                                            setCodeGenerated(text.target.value)
                                                        }}
                                                        onKeyDown={(event) => handleKeyDown(event, '2')}
                                                    />
                                                </FloatingLabel>
                                                <div className="d-grid gap-2">

                                                    <button type='submit'
                                                        style={{ background: '#327189' }}
                                                        className='btn btn-sm' onClick={verificarCodigo}>
                                                        <div className='text-center text-white fw-bold m-2'>VERIFICAR CODIGO</div>
                                                    </button>
                                                </div>
                                            </>
                                        }
                                    </>
                                    : null}


                                {usuarioModificado ?
                                    <>
                                        <FloatingLabel
                                            controlId="floatingPassword"
                                            label="Contrasena"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="password"
                                                size='sm'
                                                placeholder="Password"
                                                required={true}
                                                value={password}
                                                onChange={text => {
                                                    setpassword(text.target.value)
                                                }}
                                            />
                                        </FloatingLabel>
                                        <FloatingLabel
                                            controlId="floatingPassword"
                                            label="Confirmar contrasena"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                type="password"
                                                size='sm'
                                                placeholder="Password"
                                                required={true}
                                                value={confirmPassword}
                                                onChange={text => {
                                                    setConfirmPassword(text.target.value)
                                                }}
                                                onKeyDown={(event) => handleKeyDown(event, '3')}
                                            />
                                        </FloatingLabel>
                                        <div className="d-grid gap-2">

                                            <button type='submit'
                                                style={{ background: '#327189' }}
                                                className='btn btn-sm' onClick={cambiarClave}>
                                                <div className='text-center text-white fw-bold m-2'>CAMBIAR CONTRASEÑA</div>
                                            </button>
                                        </div>
                                    </>

                                    : null}
                            </div>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </>)
}

export default GestionarClave;